export const ATTRIBUTE_TYPES = {
  DEBILIDAD: '4CE37F22-14EB-44EC-8F36-9C2452CE885A',
  FORTALEZA: 'D411596B-6500-415E-B4D9-3B838550CADD',
};